const entity = {
  name: {
    singular: 'client',
    plural: 'clients'
  },
  collection: 'clients',
  tableHeaders: [
    { text: 'Nome', value: 'name' },
    { text: 'Email', value: 'email' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    name: '',
    email: '',
    tel: '',
    state: ''
  },
  schema: {
    fields: [
      {
          type: 'input',
          inputType: 'text',
          label: 'Nome',
          model: 'name',
          required: true
      },
      {
          type: 'input',
          inputType: 'text',
          label: 'Email',
          model: 'email',
          required: true
      },
      {
          type: 'input',
          inputType: 'text',
          label: 'Telefone',
          model: 'tel',
          required: true
      },
      {
          type: 'input',
          inputType: 'text',
          label: 'Estado',
          model: 'state',
          required: true
      }
    ]
  },
  formOptions: {
    validateAfterLoad: false,
    validateAfterChanged: false,
    validateAsync: false
  }
}

export default [
  {
    path: '/clients',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "clients" */ '../../components/Crud/CrudList.vue')
  }, {
    path: '/clients/new',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "clients" */ '../../components/Crud/CrudForm.vue')
  }, {
    path: '/clients/:id',
    meta: {
      entity,
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "clients" */ '../../components/Crud/CrudForm.vue')
  }
]
